


import { Routes, RouterModule } from '@angular/router';
import { WorkflowStepComponent } from './workflowstep.component';

const routes: Routes = [
    {
        path: '',
        component: WorkflowStepComponent
    },
];

export const WorkflowStepRoutes = RouterModule.forChild(routes);
